import { defineStore } from 'pinia';

export const useKillswitchesStore = defineStore('killswitchesStore', {
  state: () => ({
    persistentLoginEnabled: false,
    persistentLoginForLoyaltyHubEnabled: false,
    /** BCOM triple-points copy refresh (from killswitches API in legacy Vuex root state). */
    triplePointsDayBenefitUpdateEnabled: false,
    /** BCOM Top of the List Upgrade killswitch. */
    blmTopOfListUpgradeEnabled: false,
    /** Global gate for the credit card acquisition (NAD) enhancements. */
    cardActivationEnhancementsEnabled: false,
    /** Loyalty Hub-specific gate for the new credit card acquisition banner. */
    cardActivationEnhancementsLoyaltyHubEnabled: false,
  }),
});
